import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=2c2568be&"
import script from "./IconSelector.vue?vue&type=script&lang=js&"
export * from "./IconSelector.vue?vue&type=script&lang=js&"
import style0 from "./IconSelector.vue?vue&type=style&index=0&id=2c2568be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports